import { MasterHelper } from "../../utilities";

export class SingleImportUpdateModel {
    id: number | null;
    UserId: number | null;
    publishDate: string | null;
    regulator: string | null;
    geography: string;
    country: string;
    description: string;
    pubType: string;
    title: string;
    hyperlink: string;
    ruleTopic: string;
    ruleTopicMultiple: string[];
    mappingId:string;
    jurisdiction:string;
    constructor() {
        this.id = null;
        this.UserId = null;
        this.publishDate = MasterHelper.getCurrrentDateTime('YYYY-MM-DD').toString();
        this.regulator = null;
        this.country = "";
        this.geography="";
        this.pubType = "";
        this.title = "";
        this.description = "";
        this.hyperlink = '';
        this.ruleTopic = "";
        this.mappingId="";
        this.jurisdiction="";
        this.ruleTopicMultiple=[];
    }
}